const RewardTypes = {
  REWARD_TRANSTYPE_EARNED: '0',
  REWARD_TRANSTYPE_USED: '1',
  REWARD_TRANSTYPE_BOUGHT: '2'
};

RewardTypes.install = function (Vue) {
    Vue.prototype.$getConstRewardType = (key) => {
        return RewardTypes[key];
    }
}

export default RewardTypes;
